<template>
  <ServicePageLayout
    title="Soft Water"
    subtitle="ระบบน้ำอ่อน"
    icon="mdi-grain"
    icon-color="primary"
    breadcrumb="Operations"
    :available="sanitary_machine.length > 0"
  >
    <v-tabs v-model="tab" class="industrial-tabs">
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">Dashboard</v-tab>
      <v-tab v-if="main_level.length > 0 || main_meter.length > 0">History</v-tab>
      <v-tab>Machine</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Dashboard /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item v-if="main_level.length > 0 || main_meter.length > 0">
        <v-card flat class="service-content-panel">
          <v-card-text><Table /></v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item>
        <v-card flat class="service-content-panel">
          <v-card-text><MACHINE_VIEW :assets="sanitary_machine" /></v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </ServicePageLayout>
</template>

<script>
import ServicePageLayout from '@/components/layout/ServicePageLayout.vue'
import Dashboard from '@/components/soft/sanitary_dashboard'
import Table from '@/components/soft/sanitary_table'
import MACHINE_VIEW from '@/components/machine/machine_view'

export default {
  name: 'SoftWaterView',
  components: {
    ServicePageLayout,
    Dashboard,
    Table,
    MACHINE_VIEW
  },
  computed: {
    main_meter() {
      return this.$store.state.SoftWater.mainWaterMeter
    },
    main_level() {
      return this.$store.state.SoftWater.mainWaterLevel
    },
    sanitary_machine() {
      return this.$store.state.Asset.assetAll.filter(
        el => el.machine === true && el.serviceId === 'df062dab-9d10-4c0e-8b86-4a06b94eeb0d'
      )
    }
  },
  data() {
    return { tab: null }
  },
}
</script>
